import { Injectable } from '@angular/core';

/**
 * Service to manage Sentry release configuration.
 * Provides version and environment-specific settings for error tracking.
 */
@Injectable({
  providedIn: 'root',
})
export class SentryConfigService {
  /**
   * Get Sentry configuration based on environment.
   */
  getConfig(environment: 'production' | 'staging' | 'development') {
    const packageJson = require('../../../../package.json');
    const version = packageJson.version;
    const release = `rhogicsom-frontend@${version}`;

    const baseConfig = {
      release,
      version,
    };

    // Environment-specific sampling rates
    const samplingConfig = {
      production: {
        tracesSampleRate: 0.1, // 10% of transactions in production
        replaysSessionSampleRate: 0.1, // 10% of sessions
        replaysOnErrorSampleRate: 1.0, // 100% of error sessions
      },
      staging: {
        tracesSampleRate: 0.5, // 50% of transactions in staging
        replaysSessionSampleRate: 0.3, // 30% of sessions
        replaysOnErrorSampleRate: 1.0, // 100% of error sessions
      },
      development: {
        tracesSampleRate: 1.0, // 100% of transactions in dev
        replaysSessionSampleRate: 1.0, // 100% of sessions
        replaysOnErrorSampleRate: 1.0, // 100% of error sessions
      },
    };

    return {
      ...baseConfig,
      ...samplingConfig[environment],
    };
  }
}
